import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "setting-data" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "flex-fill" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, null, -1)
const _hoisted_7 = {
  class: "form-horizontal",
  id: "frm_change_cred",
  name: "frm_change_cred",
  role: "form"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6 form-group" }
const _hoisted_10 = { for: "oLang" }
const _hoisted_11 = { value: "en" }
const _hoisted_12 = { value: "fr" }
const _hoisted_13 = { class: "col-md-6 form-group" }
const _hoisted_14 = { for: "oOffice" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6 form-group" }
const _hoisted_18 = { for: "oFYear" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "col-md-6 form-group" }
const _hoisted_21 = { for: "oCurrency" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6 form-group" }
const _hoisted_25 = { for: "oFYear" }
const _hoisted_26 = { value: "-" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "col-md-6 form-group" }
const _hoisted_29 = { for: "oItems" }
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<option value=\"5\">5</option><option value=\"10\">10</option><option value=\"15\">15</option><option value=\"20\">20</option><option value=\"25\">25</option>", 5)
const _hoisted_35 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.isStartLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'spinner'],
          class: "fs-6-x"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("form", null, [
          _createElementVNode("h2", null, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'wrench'] }),
            _createTextVNode(" " + _toDisplayString(_ctx.language.otherSettings), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.language.other_setts_def), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.language.otherSettings), 1),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn-xs",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveOthersetts()))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                _createTextVNode(" " + _toDisplayString(_ctx.language.refresh), 1)
              ]),
              _createTextVNode("  "),
              _createElementVNode("button", {
                class: "btn-xs",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveOthersetts()))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'save'] }),
                _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
              ])
            ])
          ]),
          _hoisted_6,
          _createElementVNode("form", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.language.language), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.otherOptionsRec.OptLang) = $event)),
                  id: "oLang",
                  class: "form-control-sel"
                }, [
                  _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.language.lang_en), 1),
                  _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.language.lang_fr), 1)
                ], 512), [
                  [_vModelSelect, _ctx.otherOptionsRec.OptLang]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.language.office), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.otherOptionsRec.OptBranch) = $event)),
                  id: "oOffice",
                  class: "form-control-sel"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfBranches, (xOffice) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: xOffice.CodeBranch,
                      key: xOffice.CodeBranch
                    }, _toDisplayString(xOffice.FullNameBranch), 9, _hoisted_15))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.otherOptionsRec.OptBranch]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.language.financialYear), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.otherOptionsRec.OptYear) = $event)),
                  id: "oFYear",
                  class: "form-control-sel"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfFinYears, (xFY) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: xFY.YearWork,
                      key: xFY.YearWork
                    }, _toDisplayString(xFY.YearWork), 9, _hoisted_19))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.otherOptionsRec.OptYear]
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.language.currency), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.otherOptionsRec.OptDevise) = $event)),
                  id: "oCurrency",
                  class: "form-control-sel"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfDevises, (xDev) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: xDev.DevISO,
                      key: xDev.DevISO
                    }, _toDisplayString(xDev.DevName), 9, _hoisted_22))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.otherOptionsRec.OptDevise]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.language.defSmsScct), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.otherOptionsRec.DefaultSMSAcct) = $event)),
                  id: "oFYear",
                  class: "form-control-sel"
                }, [
                  _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.language.none), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfSmsAccts, (xFY) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: xFY.SmsAccount,
                      key: xFY.SmsAccount
                    }, _toDisplayString(xFY.SmsAccount), 9, _hoisted_27))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.otherOptionsRec.DefaultSMSAcct]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.language.itemsPerPage), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.otherOptionsRec.ItemsPerTable) = $event)),
                  id: "oItems",
                  class: "form-control-sel"
                }, _hoisted_35, 512), [
                  [_vModelSelect, _ctx.otherOptionsRec.ItemsPerTable]
                ])
              ])
            ])
          ])
        ])
      ]))
}